import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {ContextDataValueEmb} from './ContextDataValueEmb';

export class ContextData extends ConnectBasicEntityExt {
dataType: string;
dataValue: ContextDataValueEmb;
kind: string;
processCode: string;
processUuid: string;
visionCode: string;
}

